export default __webpack_public_path__ + "static/Donate_Yatre-d51d40ca3efca9197e7329013246fcaf.png";